import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const ReviewNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="url(#ReviewNotification1)" />
    <Path
      d="M12 11.42a2.333 2.333 0 0 0 2.289-2.79 2.336 2.336 0 0 0-3.182-1.702A2.334 2.334 0 0 0 12 11.419ZM12.792 12.664a4.082 4.082 0 0 1 2.09 1.113c.4.38 1.201 1.489 1.201 2.89a.584.584 0 0 1-.583.583h-7a.583.583 0 0 1-.583-.584 4.087 4.087 0 0 1 4.875-4.002Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="ReviewNotification1"
        x1={12}
        y1={-3}
        x2={12}
        y2={27}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#6785F1" />
        <Stop offset="1" stopColor="#0078D1" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default ReviewNotification;
